module.exports = __webpack_public_path__ + "img/unactiveHyperlink.6ad6859f.svg";